<template>
  <div>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        class="border-table-employee"
        item-key="_id"
        :headers="headers"
        :items="employeeDataApprove"
        :loading="loading"
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        disable-sort
      >
      <template v-slot:[`item.no`]="{ item }">
        {{ (perPage*(page-1)) + employeeDataApprove.indexOf(item)+1 }}
      </template>
        <template v-slot:[`item.userImg`]="{ item }">
          <td style="width: 100px; height: 100px;">
            <img :src="item.img"
            :lazy-src="require('@/assets/icons/no_user.png')"
            style="width: 70px; height: 55px">
          </td>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <tr class="txt-center">
            <td>
              <v-chip-group
                active-class="primary--text"
                column
              >
              <v-tooltip
                bottom
                v-for="(el, index) in item.status.filter(e => e.approverStatus === 'cancel').length > 0 ? [item.status.filter(e => e.approverStatus === 'cancel')[0]] : item.status"
                :key="index.toString()"
              >
                <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  :color="['approve','acknowledge'].includes(el.approverStatus)? 'green lighten-2': ['reject'].includes(el.approverStatus)? 'red lighten-2':['cancel'].includes(el.approverStatus)? 'grey':'orange lighten-2'"
                >
                  {{ el.approverStatusTH }} {{ el.approverStatus==='cancel'? '':`(ลำดับที่ ${el.approverNo} )` }}
                </v-chip>
                </template>
                <span class="label-table-action">
                  {{ el.approverEmployeeId }} {{ el.approverName }}
                  <br>ความเห็น : {{ el.approverComment || '-' }}
                </span>
              </v-tooltip>
              </v-chip-group>
            </td>
          </tr>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row>
            <v-col cols="3" md="3" sm="3" lg="4" xl="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    color="#2196F3"
                    dark
                    icon
                    class="btn-edit-dep mt-3 mb-3"
                    @click="view(item)">
                    <v-icon dark color="white" small>fa-eye</v-icon>
                  </v-btn>
                </template>
                <span class="label-table-action">จัดการพนักงาน</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <DialogShowDetail/>
  </div>
</template>

<script>
import { getSelectEmployeeApprove, getEmployeeListApprove, getCompanyFilter } from '@/API/API'
import DialogShowDetail from '../_dialog/dialogShowDetail'
import { OverlayLoading } from '@/components/index'
import { EventBus } from '@/EventBus'

export default {
  components: {
    OverlayLoading, DialogShowDetail
  },
  data () {
    return {
      expanded: [],
      togglers: {},
      keywordReqNo: [],
      keywordCompanyName: [],
      keywordReqType: '',
      keywordUserName: '',
      keywordUserPosition: '',
      keywordStatus: '',
      loading: true,
      tokenUser: '',
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no',
          sortable: false
        },
        { text: 'หมายเลขคำร้อง', value: 'reqEmployeeNo' },
        { text: 'ชื่อ-สกุล', value: 'employeeName' },
        { text: 'บริษัท', value: 'companyName' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'ประเภทเอกสาร', value: 'requestType' },
        { text: 'สถานะ', value: 'status', align: 'center' },
        { text: 'Actions', value: 'actions', sortable: false }
        // { text: '', value: 'data-table-expand' }
      ],
      mockup: [],
      selectData: [],
      employeeDataApprove: [],
      total: -1,
      perPage: 15,
      page: 1
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    try {
      this.initData()
    } catch (error) {
    } finally {
      this.loading = false
    }
  },
  mounted () {
    EventBus.$on('filterEmployeeApprove', this.getSelect)
  },
  methods: {
    getSelect (data) {
      this.keywordReqNo = data.reqEmployeeNo
      this.keywordCompanyName = data.companyName
      this.keywordReqType = data.requestType
      this.keywordUserName = data.employeeName
      this.keywordUserPosition = data.position
      this.keywordStatus = data.requestStatus
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.initDataTableApprove()
    },
    initData () {
      this.initSelectData()
      this.initDataTableApprove()
      this.getCompanyFilterApprove()
    },
    async initSelectData () {
      this.loading = true
      this.selectData = []
      const token = this.tokenUser

      try {
        const res = await getSelectEmployeeApprove(token)
        if (res.success) {
          if (res.result.length) {
            this.selectData = res.result
          }
        } else {
          // console.log(res)
        }
        EventBus.$emit('getFilterEmployeeApprove', this.selectData)
        EventBus.$emit('selectEmployeeApprove', res.result)
      } catch (error) {
        // console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getCompanyFilterApprove () {
      const token = this.tokenUser
      try {
        const res = await getCompanyFilter(token)
        if (res.success) {
          if (res.result.length) {
            this.selectData = res.result
          }
        } else {
          // console.log(res)
        }
        EventBus.$emit('selectCompany', res.result)
      } catch (error) {
        // alert(error)
        // console.log(error)
      } finally {
        this.loading = false
      }
    },
    changePerPage (value) {
      this.perPage = value
      this.initDataTableApprove()
    },
    changePage (value) {
      this.page = value
      this.initDataTableApprove()
    },
    async initDataTableApprove () {
      const self = this
      self.loading = true
      self.employeeDataApprove = []
      const temp = []
      var obj = {
        reqEmployeeNo: this.keywordReqNo,
        employeeName: this.keywordUserName,
        companyName: this.keywordCompanyName,
        requestType: this.keywordReqType,
        requestStatus: this.keywordStatus,
        position: this.keywordUserPosition,
        limit: this.perPage,
        page: this.page
      }

      try {
        const res = await getEmployeeListApprove(obj, this.tokenUser)
        console.log('res', res)
        if (res.result) {
          self.total = res?.count || -1
          self.isLoading = false
          res.result.map((el, index) => {
            if (el.requestType === 'new') {
              el.requestType = 'เพิ่มบุคคล'
            } else if (el.requestType === 'transfer') {
              el.requestType = 'ย้ายฝ่าย'
            } else if (el.requestType === 'resign') {
              el.requestType = 'ลาออก'
            } else if (el.requestType === 'transferPosition') {
              el.requestType = 'ย้ายตำแหน่ง'
            } else if (el.requestType === 'resignPosition') {
              el.requestType = 'ลาออกจากตำแหน่ง'
            } else if (el.requestType === 'resignEmployee') {
              el.requestType = 'ลาออกบริษัท'
            }
            temp.push({
              no: index + 1,
              ...el
            })
          })
          // console.log(temp)
          self.employeeDataApprove = temp
        } else {
          // console.log('Res', res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    editPage (data) {
      // this.$router.push('/manageemployee/update')
      this.$router.push({
        name: 'manageEmployeeUpdate',
        params: {
          item: data,
          id: data._id
        }
      })
    },
    view (item) {
      EventBus.$emit('openDialogManageApprove', item)
    },
    manageLineWork (data) {
      // console.log('manage Employee', data)
    },
    gotocreate () {
      this.$router.push('manageemployee/create')
    }
  }
}
</script>

<style>
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>
